"use strict";

function isOlderThan(birthDate, minAge) {
    let today = new Date();
    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
        age--;
    }
    return age >= minAge;
}

export default function age$config(options) {
    if (!options.minAge) throw new Error('Missing required minAge for age validator');
    options = {
        type: 'age',
        minAge: 18,
        message: `You must be of legal age in your state of residence`,

        ...options
    };
    const minAge = (options.age * 31540000);
    return function age(val, vm) {

        let dd, mm, yyyy, date;

        if (vm && options.fields) {
            if (options.fields.dd) {
                dd = vm.path(options.fields.dd);
            }
            if (options.fields.mm) {
                mm = vm.path(options.fields.mm);
            }
            if (options.fields.yyyy) {
                yyyy = vm.path(options.fields.yyyy);
            }
            //use required validators.
            if (!(mm && dd && yyyy)) {
                return;
            }
            date = new Date(yyyy, mm, dd, 23, 59, 999);

        } else {
            //use required validators.
            if (val == null || val == '') {
                return;
            }
            date = new Date(val);
        }

        if (!isOlderThan(date, options.minAge)) {
            return {
                ...options
            }
        }
    }
}



/** WEBPACK FOOTER **
 ** ./src/validators/age.js
 **/